export default {
    props: {
        columnMenuColumns: {
            type: Boolean,
            default: undefined,
            kComposite: 'columnMenu.columns'
        }, 
        columnMenuFilterable: {
            type: Boolean,
            default: undefined,
            kComposite: 'columnMenu.filterable'
        }, 
        columnMenuSortable: {
            type: Boolean,
            default: undefined,
            kComposite: 'columnMenu.sortable'
        }, 
        columnMenuMessagesColumns: {
            type: String,
            default: undefined,
            kComposite: 'columnMenu.messages.columns'
        }, 
        columnMenuMessagesFilter: {
            type: String,
            default: undefined,
            kComposite: 'columnMenu.messages.filter'
        }, 
        columnMenuMessagesSortAscending: {
            type: String,
            default: undefined,
            kComposite: 'columnMenu.messages.sortAscending'
        }, 
        columnMenuMessagesSortDescending: {
            type: String,
            default: undefined,
            kComposite: 'columnMenu.messages.sortDescending'
        }, 
        columnMenuMessagesSettings: {
            type: String,
            default: undefined,
            kComposite: 'columnMenu.messages.settings'
        }, 
        columnMenuMessagesDone: {
            type: String,
            default: undefined,
            kComposite: 'columnMenu.messages.done'
        }, 
        columnMenuMessagesLock: {
            type: String,
            default: undefined,
            kComposite: 'columnMenu.messages.lock'
        }, 
        columnMenuMessagesUnlock: {
            type: String,
            default: undefined,
            kComposite: 'columnMenu.messages.unlock'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGrid/ColumnMenu.js